
import React, { Component } from "react";
import './index.css';
import { BrowserRouter, Link, NavLink, useNavigate, withRouter } from 'react-router-dom';

import Header from './layout/Header';
import Footer from './layout/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import Button from '@mui/material/Button';




const itemData = [
    {
        img: 'https://kamdhenupaints.com/images/csr/1.jpg',
    },
    {
        img: 'https://kamdhenupaints.com/images/csr/2.jpg',
    },
    {
        img: 'https://kamdhenupaints.com/images/csr/3.jpg',
    },
    {
        img: 'https://kamdhenupaints.com/images/csr/4.jpg',
    },
    {
        img: 'https://kamdhenupaints.com/images/csr/5.jpg',
    },
    {
        img: 'https://kamdhenupaints.com/images/csr/6.jpg',
    },
];




function BoardofDirectors() {

    return (
        <>
            <div><Header /></div>
            <div className="contentblock">



                <section className="fix ptb-50" id="directors">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 mb-40">
                                <div className="section__title-wrapper text-center mb-40">

                                    <h2 className="section__title section__title-2 font-40 mb-20">Board of Directors
                                    </h2>
                                    <p>The people behind Kamdhenu’s success are individuals of great vision, integrity and professionalism, whose able guidance is escalating/elevating Kamdhenu to unparalleled heights of success and recognition. We are deeply honoured to have such able professionals in the helm of our affairs.

                                    </p>




                                </div>

                                <div className="directorlist">
                                    <div className="row">
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                                            <div className="features__item-3 text-center mb-30">
                                                <div className="features__icon-3 mb-30 p-relative">
                                                    <span>
                                                        <img src={process.env.PUBLIC_URL + '/images/directors/sunil.jpg'} alt="Slide" />
                                                    </span>
                                                </div>
                                                <div className="features__content-3">
                                                    <h3 className="features__title features__title-3">
                                                        Shri Sunil Kumar Agarwal
                                                        <small>Chairman</small>
                                                    </h3>
                                                    <p>Shri Sunil Kumar Agarwal is one of the founding members of Kamdhenu Ventures Limited. He brings with him more than
                                                        35 years of experience in marketing which helped him build an efficient pan-India
                                                        network to help Kamdhenu reach new heights.</p>
                                                    <Link to="/sunil-kumar"><Button variant="contained">Read More</Button></Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                                            <div className="features__item-3 text-center mb-30">
                                                <div className="features__icon-3 mb-30 p-relative">
                                                    <span>
                                                        <img src={process.env.PUBLIC_URL + '/images/directors/saurbh.jpg'} alt="Slide" />
                                                    </span>
                                                </div>
                                                <div className="features__content-3">
                                                    <h3 className="features__title features__title-3">
                                                        Shri Saurabh Agarwal
                                                        <small>Managing Director</small>
                                                    </h3>
                                                    <p>Shri Saurabh Agarwal is a dynamic entrepreneur and an expert in complex plants
                                                        operations. He has been associated with Kamdhenu Ventures Limited since 2019. He is B.E. in Mechanical Engineering from R.V. College of Engineering, Bangaluru.</p>
                                                    <Link to="/saurabh-aggarwal"><Button variant="contained">Read More</Button></Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                                            <div className="features__item-3 text-center mb-30">
                                                <div className="features__icon-3 mb-30 p-relative">
                                                    <span>
                                                        <img src={process.env.PUBLIC_URL + '/images/directors/sachin.jpg'} alt="Slide" />
                                                    </span>
                                                </div>
                                                <div className="features__content-3">
                                                    <h3 className="features__title features__title-3">
                                                        Shri Sachin Agarwal
                                                        <small>Non-Executive Director</small>
                                                    </h3>
                                                    <p>Shri Sachin Agarwal is a BE in Industrial Engineering from R.V. College of Engineering, Bangalore. He
                                                        got his MBA in International Management from the UK. He joined Kamdhenu Ventures Limited in 2019 and
                                                        has been a vital part of the company&#39;s management team.</p>
                                                    <Link to="/sachin-agarwal"><Button variant="contained">Read More</Button></Link>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                                            <div className="features__item-3 text-center mb-30">
                                                <div className="features__icon-3 mb-30 p-relative">
                                                    <span>
                                                        <img src={process.env.PUBLIC_URL + '/images/directors/MA_ID.jpg'} alt="Slide" />
                                                    </span>
                                                </div>
                                                <div className="features__content-3">
                                                    <h3 className="features__title features__title-3">
                                                        Shri Madhusudan Agarwal
                                                        <small>Independent Director</small>
                                                    </h3>
                                                    <p>Shri Madhusudan Agarwal, University of Delhi alumnus, is a fellow member of The Institute of Chartered
                                                        Accountants of India (ICAI) since 1987. He has more than three decades of professional experience in
                                                        the field of audit, management consultancy, tax, company law matters and worked with various
                                                        corporates across industries including steel, print media, healthcare, digital media, financial services,
                                                        textile, real estate, automobiles etc. </p>
                                                    <Link to="/madhusudan-agarwal"><Button variant="contained">Read More</Button></Link>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                                            <div className="features__item-3 text-center mb-30">
                                                <div className="features__icon-3 mb-30 p-relative">
                                                    <span>
                                                        <img src={process.env.PUBLIC_URL + '/images/directors/ramesh.jpg'} alt="Slide" />
                                                    </span>
                                                </div>
                                                <div className="features__content-3">
                                                    <h3 className="features__title features__title-3">
                                                        Shri Ramesh Chand Surana
                                                        <small>Independent Director</small>
                                                    </h3>
                                                    <p>Shri Ramesh Chand Surana, a management post-graduate from Banaras Hindu University has to his credit more than 37 years
                                                        of rich and extensive experience in Finance, Marketing, Project Execution and plant management. He
                                                        started his career with HEG Limited in 1976 as Management Trainee immediately after his MBA from
                                                        BHU. he became President in 1997, and then, elevated to the position of CEO in 1999 in HEG Limited.</p>
                                                    <Link to="/ramesh-chand-surana"><Button variant="contained">Read More</Button></Link>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                                            <div className="features__item-3 text-center mb-30">
                                                <div className="features__icon-3 mb-30 p-relative">
                                                    <span>
                                                        <img src={process.env.PUBLIC_URL + '/images/directors/nishal.jpg'} alt="Slide" />
                                                    </span>
                                                </div>
                                                <div className="features__content-3">
                                                    <h3 className="features__title features__title-3">
                                                        Smt. Nishal Jain
                                                        <small>Independent Director</small>
                                                    </h3>
                                                    <p>Smt. Nishal Jain, PGDHR from Institute of Management and Technology, Kolkata is a seasoned
                                                        professional in the field of Human Resources Management. She has over 15 years of professional
                                                        experience in areas like Recruitment, Manpower Planning, Compensation Planning, Appraisals,
                                                        Employee Engagement &amp; related HRBP role. She had worked with various industries handling a team of
                                                        HR executives &amp; looked after the end to end recruitment. </p>
                                                    <Link to="/nishal-jain"><Button variant="contained">Read More</Button></Link>
                                                </div>
                                            </div>
                                        </div>



                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <section className="fix ptb-100" id="committies">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 mb-40">
                                <div className="section__title-wrapper text-center mb-40">

                                    <h2 className="section__title section__title-2 font-36 mb-20">Board Committees
                                    </h2>


                                </div>
                            </div>

                            <div className="tableblock">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 mb-40">
                                        <h6>Audit Committee</h6>
                                        <table cellPadding={0} cellSpacing={0} width={100}>
                                            <tr>
                                                <th>Sr. No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>Shri Madhusudan Agarwal</td>
                                                <td>Chairman</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Shri Saurabh Agarwal</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Shri Ramesh Chand Surana</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Smt. Nishal Jain</td>
                                                <td>Member</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 mb-40">
                                        <h6>Risk Management Committee</h6>
                                        <table cellPadding={0} cellSpacing={0} width={100}>
                                            <tr>
                                                <th>Sr. No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                            </tr>

                                            <tr>
                                                <td>1</td>
                                                <td>Shri Sunil Kumar Agarwal</td>
                                                <td>Chairman</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Shri Saurabh Agarwal</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Shri Madhusudan Agarwal</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Smt. Nishal Jain</td>
                                                <td>Member</td>
                                            </tr>

                                            <tr>
                                                <td>5</td>
                                                <td>Shri Vineet Agarwal</td>
                                                <td>Member</td>
                                            </tr>
                                        </table>
                                    </div>

                                    <div className="col-xl-6 col-lg-6 mb-40">
                                        <h6>Stakeholders Relationship Committee</h6>
                                        <table cellPadding={0} cellSpacing={0} width={100}>
                                            <tr>
                                                <th>Sr. No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>Shri Madhusudan Agarwal</td>
                                                <td>Chairman</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Shri Saurabh Agarwal</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Smt. Nishal Jain</td>
                                                <td>Member</td>
                                            </tr>
                                        </table>
                                    </div>



                                    <div className="col-xl-6 col-lg-6 mb-40">
                                        <h6>Nomination and Remuneration Committee</h6>
                                        <table cellPadding={0} cellSpacing={0} width={100}>
                                            <tr>
                                                <th>Sr. No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                            </tr>

                                            <tr>
                                                <td>1</td>
                                                <td>Shri Ramesh Chand Surana</td>
                                                <td>Chairman</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Shri Madhusudan Agarwal</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Smt. Nishal Jain</td>
                                                <td>Member</td>
                                            </tr>
                                        </table>
                                    </div>






                                </div>
                            </div>
                        </div>
                    </div>
                </section>




            </div>
            <div><Footer /></div>
        </>
    );
}

export default BoardofDirectors;
